import { render } from "./close.svg?vue&type=template&id=7a02376b"
const script = {}

import exportComponent from "/__w/dryrobe.com-website/dryrobe.com-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__